module.exports = __webpack_public_path__ + "img/complete.37a13166.svg";